// Global config variables. Access: config.yay = hooray
var config = ( function() {
  'use strict';

  return {
    'testimonialCycleSpeed': 15000
  };

}());
